<template>
  <div class="my-account">
    <div class="account-container">
      <div class="account-header">
        <div class="title-section">
          <div class="title">My Account</div>
        </div>
        <div class="title-section usage-section-title">
          <div class="title">Usage</div>
        </div>
        <!-- <div class="dark-mode-toggle">
          Dark Mode
          <el-switch v-model="darkMode" @change="toggleDarkMode"></el-switch>
        </div> -->
      </div>

      <div class="content-area">
        <!-- 左侧用户信息卡片 -->
        <div class="user-section">
          <div class="user-card">
            <div class="user-avatar">
              <div class="avatar-circle">{{ userInitial }}</div>
            </div>
            <div class="user-info">
              <h3>{{ username }}</h3>
              <p>{{ email }}</p>
              <p class="created-date">Date created: {{ createdDate }}</p>
            </div>
            <div class="card-actions">
              <button @click="logout" class="logout-btn">Log out</button>
            </div>
          </div>
          <div class="delete-account">
            <button @click="deleteaccount()" class="delete-btn">Delete Account</button>
          </div>
        </div>

        <!-- 右侧使用情况 -->
        <div class="usage-section">
          <div class="usage-card">
            <div class="usage-header">
              <h3>Your {{ minfo }} Plan Usage Per Month:</h3>
            </div>

            <div class="usage-progress-container">
              <!-- Record Live Lecture -->
              <div class="usage-item">
                <div class="usage-label">
                  <span>Record Live Lecture</span>
                  <span v-if="fileusage.real.extra_minute">({{ fileusage.real.progress }}% remaining) {{
                    fileusage.real.current }}/({{ fileusage.real.total
                    }}+{{ fileusage.real.extra_minute }})min</span>
                  <span v-else>({{ fileusage.real.progress }}% remaining) {{ fileusage.real.current }}/{{ fileusage.real.total
                  }}min</span>
                </div>
                <div class="progress-bar">
                  <div class="progress progress-limited" :style="{ width: fileusage.real.progress + '%' }"></div>
                </div>
              </div>

              <!-- Upload Audio and YouTube -->
              <div class="usage-item">
                <div class="usage-label">
                  <span>Audio and YouTube</span>
                  <span v-if="isFreeUser()">
                    ({{ fileusage.lecture.progress }}% remaining) {{ fileusage.lecture.current }}/{{
                      fileusage.lecture.total }}min
                  </span>
                  <span v-else>Unlimited</span>
                </div>
                <div class="progress-bar">
                  <div class="progress" :class="isFreeUser() ? 'progress-limited' : 'progress-unlimited'"
                    :style="{ width: isFreeUser() ? fileusage.lecture.progress + '%' : '100%' }"></div>
                </div>
              </div>

              <!-- PDF Upload -->
              <div class="usage-item">
                <div class="usage-label">
                  <span>PDF Upload</span>
                  <span v-if="isFreeUser()">
                    ({{ fileusage.pdf.progress }}% remaining) {{ fileusage.pdf.current }}/{{ fileusage.pdf.total }}
                  </span>
                  <span v-else>Unlimited</span>
                </div>
                <div class="progress-bar">
                  <div class="progress" :class="isFreeUser() ? 'progress-limited' : 'progress-unlimited'"
                    :style="{ width: isFreeUser() ? fileusage.pdf.progress + '%' : '100%' }"></div>
                </div>
              </div>

              <!-- Chat Messages -->
              <div class="usage-item">
                <div class="usage-label">
                  <span>Chat Messages</span>
                  <span v-if="isFreeUser()">
                    ({{ fileusage.chat.progress }}% remaining) {{ fileusage.chat.current }}/{{ fileusage.chat.total }}
                  </span>
                  <span v-else>Unlimited</span>
                </div>
                <div class="progress-bar">
                  <div class="progress" :class="isFreeUser() ? 'progress-limited' : 'progress-unlimited'"
                    :style="{ width: isFreeUser() ? fileusage.chat.progress + '%' : '100%' }"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 账单历史 -->
    <div class="billing-section">
      <h2>Billing History</h2>
      <div class="billing-actions">
        <button @click="openbilling()" class="billing-btn">Billing Portal</button>
      </div>

      <div class="billing-table">
        <div v-if="isLoading" class="loading-spinner">
          <div class="spinner"></div>
          <p>Loading billing history...</p>
        </div>
        <table v-else>
          <thead>
            <tr>
              <th>DATE</th>
              <th>DESCRIPTION</th>
              <th>AMOUNT</th>
              <th>ORDER ID</th>
              <th>PAYMENT METHOD</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in billingHistory" :key="index">
              <td>{{ item.date }}</td>
              <td>{{ item.description }}</td>
              <td>{{ item.amount }}</td>
              <td>{{ item.orderId }}</td>
              <td>{{ item.paymentMethod }}</td>
            </tr>
            <tr v-if="billingHistory.length === 0">
              <td colspan="5" class="no-records">No billing records found</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      discordlogo: require("../../../assets/images/home/discordlogo.png"),
      darkMode: false,
      username: "Tesla An",
      email: "Tesla00616@gmail.com",
      createdDate: "11 May, 2025",
      minfo: "Monthly",
      fileusage: {
        real: {
          current: 0,
          total: 1200,
          extra_minute: 0,
          progress: 95,
        },
        lecture: {
          current: 0,
          total: 60,
          progress: 0,
        },
        pdf: {
          current: 0,
          total: 3,
          progress: 0,
        },
        chat: {
          current: 0,
          total: 3,
          progress: 0,
        }
      },
      billingHistory: [],
      isLoading: false
    };
  },
  computed: {
    userInitial() {
      return this.username ? this.username.charAt(0).toUpperCase() : 'U';
    }
  },
  mounted() {
    this.email = this.$cookies.get("email") || "Tesla00616@gmail.com";
    this.username = this.$cookies.get("username") || "Tesla An";
    this.getminfo();
    this.getBillingHistory();

    // 检查是否已有暗黑模式设置
    const savedMode = localStorage.getItem('darkMode');
    if (savedMode) {
      this.darkMode = savedMode === 'true';
      this.applyTheme();
    }
  },
  methods: {
    toggleDarkMode() {
      this.applyTheme();
      localStorage.setItem('darkMode', this.darkMode);
    },
    applyTheme() {
      document.body.classList.toggle('dark-theme', this.darkMode);
    },
    deleteaccount() {
      this.$parent.isdeletepopup = true;
    },
    JoinDiscord() {
      window.open("https://discord.gg/ffkFvpVBjt");
    },
    openbilling() {
      window.open("https://billing.stripe.com/p/login/6oE5nE1xy12Cg2AdQQ");
    },
    async getBillingHistory() {
      try {
        this.isLoading = true;
        const subid = this.$cookies.get("subid");

        // 如果没有订阅ID，可以显示默认数据或返回
        if (!subid) {
          // this.setDefaultBillingHistory();
          this.billingHistory = [];
          this.isLoading = false;
          return;
        }

        const response = await this.$axios.post("/api/getBillingHistory/", {
          subid: subid
        });

        const resdata = response.data;
        if (resdata.code == 200 && resdata.billingHistory && resdata.billingHistory.length > 0) {
          // 处理API返回的账单数据
          this.billingHistory = resdata.billingHistory.map(item => {
            return {
              date: this.formatDate(item.created_at || item.date),
              description: item.description || this.getDescriptionByType(item.type),
              amount: this.formatAmount(item.amount, item.currency),
              orderId: item.order_id || item.id,
              paymentMethod: item.payment_method || "Credit Card"
            };
          });
        } else {
          // 如果API没有返回有效数据，设置默认数据
          // this.setDefaultBillingHistory();
          this.billingHistory = [];
        }
      } catch (error) {
        console.error("Error fetching billing history:", error);
        // 出错时显示默认数据
        // this.setDefaultBillingHistory();
        this.billingHistory = [];
      } finally {
        this.isLoading = false;
      }
    },
    setDefaultBillingHistory() {
      // 设置默认账单数据
      this.billingHistory = [
        {
          date: "May 20,2025",
          description: "Subscription Update",
          amount: "USD 19.99",
          orderId: "ORDER_6f279caf7b_1747733417",
          paymentMethod: "APPLE PAY"
        },
        {
          date: "April 20,2025",
          description: "Subscription Creation",
          amount: "USD 19.99",
          orderId: "ORDER_6f279caf7b_1747733417",
          paymentMethod: "Stripe"
        },
        {
          date: "March 20,2025",
          description: "One-time Payment",
          amount: "CNY 149",
          orderId: "ORDER_6f279caf7b_1747733417",
          paymentMethod: "WECHAT PAY"
        }
      ];
    },
    formatDate(dateString) {
      // 格式化日期
      if (!dateString) return "";

      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString; // 如果日期无效，返回原始字符串

      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      return `${months[date.getMonth()]} ${date.getDate()},${date.getFullYear()}`;
    },
    formatAmount(amount, currency) {
      // 格式化金额
      if (!amount) return "";

      let formattedAmount = amount;
      // 如果金额是以分为单位的整数，需要转换为元
      if (Number.isInteger(amount) && currency) {
        formattedAmount = (amount).toFixed(2);
      }

      const currencySymbol = this.getCurrencySymbol(currency);
      return `${currencySymbol} ${formattedAmount}`;
    },
    getCurrencySymbol(currency) {
      // 获取货币符号
      if (!currency) return "USD";

      const currencyMap = {
        "USD": "USD",
        "CNY": "CNY",
        "EUR": "EUR",
        "GBP": "GBP",
        "JPY": "JPY"
      };

      return currencyMap[currency.toUpperCase()] || currency.toUpperCase();
    },
    getDescriptionByType(type) {
      // 根据交易类型生成描述
      if (!type) return "Transaction";

      const typeMap = {
        "subscription_created": "Subscription Creation",
        "subscription_updated": "Subscription Update",
        "subscription_renewed": "Subscription Renewal",
        "subscription_canceled": "Subscription Cancellation",
        "payment": "Payment",
        "refund": "Refund",
        "one_time": "One-time Payment"
      };

      return typeMap[type] || "Transaction";
    },
    async getminfo() {
      try {
        const subid = this.$cookies.get("subid");
        const response = await this.$axios.post("/api/getminfo/", {
          subid: subid,
        });
        const resdata = response.data;
        if (resdata.code == 200) {
          this.minfo = resdata.minfo;

          let planname = 'Starter';
          if (this.minfo == '1') {
            planname = 'Annual';
          }
          if (this.minfo == '2') {
            planname = 'Monthly';
          }

          this.$cookies.set("planname", planname, { expires: 30 });

          this.updateusage = resdata.updateusage;
          this.memberusage = resdata.memberusage;
          this.chatbootusage = resdata.chatbootusage;


          this.fileusage.lecture.current = Math.floor(this.updateusage.filetime_Msum / 60 * 10) / 10;
          this.fileusage.lecture.total = this.memberusage.audio_minute;
          // 最小为0
          this.fileusage.lecture.progress = Math.max(0, Math.round(100 - (this.fileusage.lecture.current / this.memberusage.audio_minute) * 100));

          this.fileusage.pdf.current = this.updateusage.pdf_upload_msum;
          this.fileusage.pdf.total = this.memberusage.pdfupload_num;
          // 最小为0
          this.fileusage.pdf.progress = Math.max(0, Math.round(100 - (this.fileusage.pdf.current / this.memberusage.pdfupload_num) * 100));

          this.fileusage.chat.current = this.chatbootusage.ask_msum;
          this.fileusage.chat.total = this.memberusage.chat_num;
          // 最小为0
          this.fileusage.chat.progress = Math.max(0, Math.round(100 - (this.fileusage.chat.current / this.fileusage.chat.total) * 100));

          let total_minute = this.memberusage.record_minute;
          let extra_minute = this.memberusage.extra_minute;
          if (!extra_minute) {
            extra_minute = 0;
          }
          if (!total_minute) {
            total_minute = 15;
          }
          if (this.minfo !== "Starter") {
            this.fileusage.lecture.progress = 100;
            this.fileusage.chat.progress = 100;
            this.fileusage.pdf.progress = 100;
          }

          //保存一位小数
          this.fileusage.real.current = Math.floor(this.updateusage.livetime_Msum / 60 * 10) / 10;
          this.fileusage.real.total = total_minute;
          this.fileusage.real.extra_minute = extra_minute;
          console.log(total_minute, extra_minute, 'total_minute, extra_minute');
          // 最小为0
          this.fileusage.real.progress = Math.max(0, Math.round(100 - (this.fileusage.real.current / (total_minute + extra_minute)) * 100));

          console.log(this.askusage);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    },
    logout() {
      this.$cookies.remove("email");
      this.$cookies.remove("subid");
      this.$cookies.remove("userlogin");
      this.$cookies.remove("username");
      this.$router.push("/");
    },
    isFreeUser() {
      return this.minfo === "Starter";
    },
  },
};
</script>

<style lang="less" scoped>
// 主题变量
@light-primary: #4361ee;
@light-secondary: #6c5ce7;
@light-success: #4CAF50;
@light-danger: #e53935;
@light-bg: #f7f9fc;
@light-text: #2d3748;
@light-border: #e2e8f0;
@light-hover: #f1f5f9;
@light-shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.04);
@light-shadow-md: 0 4px 12px rgba(0, 0, 0, 0.08);

// 暗色主题变量
@dark-primary: #6366f1;
@dark-secondary: #8b5cf6;
@dark-success: #10b981;
@dark-danger: #ef4444;
@dark-bg: #1a202c;
@dark-card-bg: #2d3748;
@dark-text: #f7fafc;
@dark-border: #4a5568;
@dark-hover: #2d3748;
@dark-shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.2);
@dark-shadow-md: 0 4px 12px rgba(0, 0, 0, 0.3);

.my-account {
  color: @light-text;
  font-family: 'Inter', 'SF Pro Display', sans-serif;
  background-color: @light-bg;
  padding: 0;
  margin: 0;

  .account-container {
    display: flex;
    flex-direction: column;

    .account-header {
      display: flex;
      align-items: center;
      padding: 1rem 2rem;
      position: relative;
      border-bottom: 1px solid @light-border;

      .title-section {
        width: 27%;

        &.usage-section-title {
          width: 73%;
        }

        .title {
          font-size: 1.3rem;
          font-weight: 600;
        }
      }

      .dark-mode-toggle {
        position: absolute;
        right: 2rem;
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 0.9rem;
        font-weight: 500;
      }
    }

    .content-area {
      display: flex;
      padding: 1rem 2rem;
      gap: 1.5rem;

      .user-section {
        flex: 0 0 25%;
        display: flex;
        flex-direction: column;
      }

      .usage-section {
        flex: 0 0 75%;
      }
    }
  }

  // 用户卡片样式
  .user-card {
    background: #fff;
    border-radius: 12px;
    padding: 1.1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    margin-bottom: 0.5rem;
    position: relative;
    text-align: center;

    .user-avatar {
      margin-bottom: 1rem;

      .avatar-circle {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        background-color: #e74c3c;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 2.5rem;
        font-weight: 600;
      }
    }

    .user-info {
      width: 100%;

      h3 {
        font-size: 1.2rem;
        font-weight: 600;
        margin: 0 0 0.3rem;
      }

      p {
        margin: 0.2rem 0;
        color: #64748b;
        font-size: 0.9rem;
      }

      .created-date {
        font-size: 0.85rem;
        margin-top: 0.5rem;
      }
    }

    .card-actions {
      margin-top: 1.5rem;
      width: 100%;

      .logout-btn {
        background-color: #f8fafc;
        color: #334155;
        border: 1px solid #e2e8f0;
        border-radius: 8px;
        padding: 0.6rem;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s ease;
        width: 100%;

        &:hover {
          background-color: #f1f5f9;
        }
      }
    }
  }

  .delete-account {
    text-align: right;

    .delete-btn {
      background-color: transparent;
      color: @light-danger;
      border: none;
      font-size: 0.9rem;
      cursor: pointer;
      padding: 0.5rem 0;
      font-weight: 500;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  // 使用情况样式
  .usage-card {
    background: #fff;
    border-radius: 12px;
    padding: 1.5rem;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    margin-right: 20px;

    .usage-header {
      margin-bottom: 1.5rem;

      h3 {
        font-size: 1rem;
        font-weight: 600;
        margin: 0;
      }
    }

    .usage-progress-container {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;
    }

    .usage-item {
      .usage-label {
        display: flex;
        justify-content: space-between;
        margin-bottom: 0.5rem;
        font-size: 0.85rem;
        color: #334155;
        font-weight: 500;
      }

      .progress-bar {
        height: 8px;
        background: rgba(0, 0, 0, 0.05);
        border-radius: 4px;
        overflow: hidden;
        display: flex;
        flex-direction: row-reverse;

        .progress {
          height: 100%;
          border-radius: 4px;

          &.progress-limited {
            background: linear-gradient(90deg, #4CAF50, #8BC34A);
          }

          &.progress-unlimited {
            background: linear-gradient(90deg, #4CAF50, #8BC34A);
          }
        }
      }
    }
  }

  // 账单历史样式
  .billing-section {
    position: relative;
    padding: 1rem 2rem;
    margin-top: 1rem;

    h2 {
      font-size: 1.3rem;
      font-weight: 600;
      margin: 1rem 0;
    }

    .billing-actions {
      position: absolute;
      top: 1rem;
      right: 2rem;

      .billing-btn {
        background-color: #6c5ce7;
        color: white;
        border: none;
        border-radius: 8px;
        padding: 0.6rem 1.5rem;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s ease;

        &:hover {
          background-color: #5a49d6;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(108, 92, 231, 0.2);
        }
      }
    }

    .billing-table {
      background: #fff;
      border-radius: 12px;
      overflow: hidden;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
      margin-top: 1rem;
      min-height: 150px;
      position: relative;

      .loading-spinner {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 150px;

        .spinner {
          width: 40px;
          height: 40px;
          border: 3px solid rgba(0, 0, 0, 0.1);
          border-radius: 50%;
          border-top-color: @light-secondary;
          animation: spin 1s ease-in-out infinite;
          margin-bottom: 10px;
        }

        p {
          color: #64748b;
          font-size: 0.9rem;
        }
      }

      .no-records {
        text-align: center;
        padding: 2rem;
        color: #64748b;
        font-style: italic;
      }

      table {
        width: 100%;
        border-collapse: collapse;

        th,
        td {
          padding: 1rem;
          text-align: left;
          border-bottom: 1px solid #f1f5f9;
        }

        th {
          background-color: #f8fafc;
          font-weight: 600;
          font-size: 0.85rem;
          color: #64748b;
          text-transform: uppercase;
        }

        td {
          font-size: 0.95rem;
          color: #334155;
        }

        tr:last-child td {
          border-bottom: none;
        }
      }
    }
  }
}

// 暗黑模式样式
:global(.dark-theme) {
  .my-account {
    background-color: @dark-bg;
    color: @dark-text;

    .account-header {
      border-bottom-color: @dark-border;
    }

    .user-card,
    .usage-card,
    .billing-table {
      background-color: @dark-card-bg;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
    }

    .user-info p {
      color: #a0aec0;
    }

    .card-actions .logout-btn {
      background-color: #4a5568;
      color: #e2e8f0;
      border-color: #4a5568;

      &:hover {
        background-color: #2d3748;
      }
    }

    .usage-item .usage-label {
      color: #e2e8f0;
    }

    .usage-item .progress-bar {
      background: rgba(255, 255, 255, 0.1);
    }

    .billing-table {
      th {
        background-color: #2d3748;
        color: #a0aec0;
      }

      td {
        color: #e2e8f0;
        border-bottom-color: #4a5568;
      }
    }
  }
}

// 响应式设计
@media (max-width: 992px) {
  .my-account {
    .account-container {
      .account-header {
        .title-section {
          width: auto;

          &.usage-section-title {
            width: auto;
            margin-left: 2rem;
          }
        }
      }

      .content-area {
        flex-direction: column;

        .user-section,
        .usage-section {
          flex: 1 1 100%;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .my-account {
    .account-container {
      .account-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;

        .title-section,
        .title-section.usage-section-title {
          width: 100%;
          margin-left: 0;
        }

        .dark-mode-toggle {
          position: static;
          margin-top: 0.5rem;
        }
      }
    }

    .billing-section {
      .billing-actions {
        position: static;
        margin-bottom: 1rem;
      }

      .billing-table {
        overflow-x: auto;

        table {
          min-width: 600px;
        }
      }
    }
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
